import { createCompoundComponent } from '@djs/react';
import { Instruction as Root } from './Instruction';
import { InstructionItem } from './components/InstructionItem';

export const Instruction = createCompoundComponent(Root, { Item: InstructionItem });
